import { app, app as api } from '@ekuaibao/whispered';
import { Fetch } from '@ekuaibao/fetch';
var PlatformList = ['app.ekuaibao.com', 'wx2.ekuaibao.com', 'feishu.ekuaibao.com', 'ekuaibao2297.eapps.dingtalkcloud.com', 'dd2.hosecloud.com'];
export function isIncludesHost() {
    var hostname = window.location.hostname;
    return PlatformList.includes(hostname);
}
export function isTestHost() {
    var testHost = ['ekb-qa.qa-dev.ekuaibao.net', 'hotfix.ekuaibao.net'];
    return testHost.includes(window.location.hostname);
}
export function logEvent(name, object) {
    var api = app;
    if (api.eventLog) {
        api.eventLog(name, object);
    }
}
export var logTableSorterChange = function (sorters, columns) {
    try {
        var menus_1 = api.store.states['@layout5']._menus;
        var baseDataPropertiesMap_1 = api.getState('@common').globalFields.baseDataPropertiesMap;
        Object.keys(sorters).forEach(function (key) {
            var col = columns.find(function (el) { return el.dataIndex === key; });
            var pathname = api.history.location.pathname;
            var thisMenus = menus_1.find(function (el) { return el.href === pathname; });
            var colDataIndexArr = col.dataIndex.split('.');
            var field = baseDataPropertiesMap_1[colDataIndexArr[colDataIndexArr.length - 1]];
            if (col) {
                var param = {
                    title: '表格字段排序',
                    name: col.dataIndex,
                    fieldType: col.dataType,
                    pathname: pathname,
                    field: field === null || field === void 0 ? void 0 : field.name,
                    fieldLabel: field === null || field === void 0 ? void 0 : field.label,
                    scene: thisMenus === null || thisMenus === void 0 ? void 0 : thisMenus.label,
                    sort: sorters[key],
                    corpId: Fetch.ekbCorpId
                };
                logEvent('table_sorter_change', param);
            }
        });
    }
    catch (error) {
        console.log(error);
    }
};
export var logTableFilterChange = function (filters, columns) {
    try {
        var menus_2 = api.store.states['@layout5']._menus;
        var baseDataPropertiesMap_2 = api.getState('@common').globalFields.baseDataPropertiesMap;
        Object.keys(filters).forEach(function (key) {
            var col = columns.find(function (el) { return el.dataIndex === key; });
            var pathname = api.history.location.pathname;
            var thisMenus = menus_2.find(function (el) { return el.href === pathname; });
            var colDataIndexArr = col.dataIndex.split('.');
            var field = baseDataPropertiesMap_2[colDataIndexArr[colDataIndexArr.length - 1]];
            if (col) {
                var param = {
                    title: '表格字段过滤',
                    name: col.dataIndex,
                    fieldType: col.dataType,
                    pathname: pathname,
                    field: field === null || field === void 0 ? void 0 : field.name,
                    fieldLabel: field === null || field === void 0 ? void 0 : field.label,
                    scene: thisMenus === null || thisMenus === void 0 ? void 0 : thisMenus.label,
                    filters: filters[key],
                    corpId: Fetch.ekbCorpId
                };
                logEvent('table_filter_change', param);
            }
        });
    }
    catch (error) {
        console.log(error);
    }
};
export var logTableGroupChange = function (group, columns) {
    try {
        var menus_3 = api.store.states['@layout5']._menus;
        var baseDataPropertiesMap_3 = api.getState('@common').globalFields.baseDataPropertiesMap;
        Object.keys(group).forEach(function (key) {
            var col = columns.find(function (el) { return el.dataIndex === key; });
            var pathname = api.history.location.pathname;
            var thisMenus = menus_3.find(function (el) { return el.href === pathname; });
            var colDataIndexArr = col.dataIndex.split('.');
            var field = baseDataPropertiesMap_3[colDataIndexArr[colDataIndexArr.length - 1]];
            if (col) {
                var isCancelGroup = group[key] === undefined;
                var param = {
                    title: isCancelGroup ? '表格字段取消分组' : '表格字段选择分组',
                    name: col.dataIndex,
                    fieldType: col.dataType,
                    pathname: pathname,
                    field: field === null || field === void 0 ? void 0 : field.name,
                    fieldLabel: field === null || field === void 0 ? void 0 : field.label,
                    scene: thisMenus === null || thisMenus === void 0 ? void 0 : thisMenus.label,
                    groupIndex: group[key],
                    corpId: Fetch.ekbCorpId
                };
                var logName = isCancelGroup ? 'table_group_cancel' : 'table_group_select';
                logEvent(logName, param);
            }
        });
    }
    catch (error) {
        console.log(error);
    }
};
export var logUploadFileError = function (file) {
    try {
        var param = {
            title: '上传文件失败',
            file: file,
            corpId: Fetch.ekbCorpId
        };
        logEvent('upload_file_error', param);
    }
    catch (error) {
        console.log(error);
    }
};
export var logPreviewAttachmentFile = function (file) {
    try {
        var param = {
            title: '预览附件',
            file: file,
            corpId: Fetch.ekbCorpId
        };
        logEvent('preview_attachment_file', param);
    }
    catch (error) {
        console.log(error);
    }
};
